const assertRectangle = (area) => {
  if (area.width < 0 || area.height < 0) {
    console.error('Invalid area', area);
  }
};

export default assertRectangle;
